var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add_review_el-star"},_vm._l((_vm.stars),function(star){return _c('i',{class:{active: star <= _vm.rating},on:{"click":function($event){return _vm.setRating(star)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }